import { type Component } from 'vue';
import type { TableRow, TableValue } from '../../utils/types';
import EcoRatingCell from './EcoRatingCell.vue';
import { wltpTableRowId } from '../../utils/mapData';

export interface TechDataTableCellProps<T = string> {
  row: TableRow<T>;
  value: TableValue<T>;
}

/**
 * Map specific tech-data row ids to a custom component
 */
export const customCellMap: Record<string, Component> = {
  [wltpTableRowId]: EcoRatingCell,
};
